import React from "react";
import { Stack, StackProps } from "@mui/material";
import MetadataListItem, { MetadataListItemProps } from "../MetadataListItem";

export interface MetadataListChipListItemProps extends StackProps {
  title: string;
  children: React.ReactNode;
  wrapperProps?: StackProps;
  contentProps?: StackProps;
  titleProps?: MetadataListItemProps["titleProps"];
  spaced?: boolean;
  spacedValue?: number;
}

const MetadataListChipListItem: React.FC<MetadataListChipListItemProps> = (props) => {
  const {
    title,
    children = [],
    wrapperProps,
    titleProps,

    spaced = true,
    spacedValue = 0.5,
    contentProps,
    ...otherProps
  } = props;

  return (
    <MetadataListItem
      alignItems="flex-start"
      title={title}
      titleProps={titleProps}
      spaced={spaced}
      contentProps={contentProps}
      {...wrapperProps}
    >
      <Stack direction="row" flexWrap="wrap" justifyContent={spaced ? "flex-start" : "flex-end"} {...otherProps}>
        {Array.isArray(children) &&
          children.map((child: any, key: number) => {
            if (child)
              return React.cloneElement(child, {
                key,
                sx: {
                  ml: spaced ? 0.25 : spacedValue ? spacedValue : 0.5,
                  mr: spaced ? 0.25 : spacedValue ? spacedValue : 0.5,
                  mb: 0.5,
                  ...child.sx,
                },
              });
          })}
      </Stack>
    </MetadataListItem>
  );
};

export default MetadataListChipListItem;
